export const NoRender: () => null = () => {
  return null;
};
